"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Popper = _interopRequireDefault(require("@eig-builder/core-ui/Popper"));

var _Grow = _interopRequireDefault(require("@eig-builder/core-ui/Grow"));

var _Paper = _interopRequireDefault(require("@eig-builder/core-ui/Paper"));

var _ClickAwayListener = _interopRequireDefault(require("@eig-builder/core-ui/ClickAwayListener"));

var _portal = _interopRequireDefault(require("@eig-builder/core-utils/portal"));

var _index = require("./index");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  transform-origin: left-start;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  margin-top: ", "px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  z-index: 10000000;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  height: 100%;\n  overflow-y: auto;\n  min-width: 230px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var DropDown = _styledComponents["default"].div(_templateObject());

var ZIndexPopper = (0, _styledComponents["default"])(_Popper["default"])(_templateObject2());
var StyledPaper = (0, _styledComponents["default"])(_Paper["default"])(_templateObject3(), function (props) {
  return props.theme.spacing(1);
});
var StyledGrow = (0, _styledComponents["default"])(_Grow["default"])(_templateObject4());

var ComboBoxDropdown = function ComboBoxDropdown(_ref) {
  var children = _ref.children;

  var _useComboBoxContext = (0, _index.useComboBoxContext)(),
      open = _useComboBoxContext.open,
      anchorRef = _useComboBoxContext.anchorRef,
      setOpen = _useComboBoxContext.setOpen;

  var handleClose = function handleClose() {
    return setOpen(false);
  };

  return open && /*#__PURE__*/_react["default"].createElement(_portal["default"], {
    elementId: "customModalRoot"
  }, /*#__PURE__*/_react["default"].createElement(ZIndexPopper, {
    open: true,
    anchorEl: anchorRef,
    placement: "bottom-start",
    keepMounted: true,
    transition: true
  }, function (_ref2) {
    var TransitionProps = _ref2.TransitionProps;
    return /*#__PURE__*/_react["default"].createElement(StyledGrow, TransitionProps, /*#__PURE__*/_react["default"].createElement(StyledPaper, {
      id: "menu-list-grow"
    }, /*#__PURE__*/_react["default"].createElement(_ClickAwayListener["default"], {
      onClickAway: handleClose
    }, /*#__PURE__*/_react["default"].createElement(DropDown, null, children))));
  }));
};

ComboBoxDropdown.propTypes = {
  children: _propTypes["default"].node.isRequired
};
var _default = ComboBoxDropdown;
exports["default"] = _default;